import { MapDispatchToProps, MapStateToProps } from 'react-redux';

import { connectWithStore } from '@common/connectWithStore';
import { RootState } from '@redux/types';
import {
  closeAlert,
  fetchData,
  getTwoFactorConfigurationState,
  resetState,
  toggleConfig,
} from '@redux/ducks/twoFactorConfiguration';

import {
  TwoFactorConfiguration,
  TwoFactorConfigurationDispatchProps,
  TwoFactorConfigurationOwnProps,
  TwoFactorConfigurationStateProps,
} from './TwoFactorConfiguration';

const mapStateToProps: MapStateToProps<TwoFactorConfigurationStateProps, TwoFactorConfigurationOwnProps, RootState> =
  state => {
    const { isLoading, config, isAlertOpen, trace } = getTwoFactorConfigurationState(state);

    return {
      isLoading,
      enabled: Boolean(config?.enabled),
      isAlertOpen,
      trace,
    };
  };

const mapDispatchToProps: MapDispatchToProps<TwoFactorConfigurationDispatchProps, TwoFactorConfigurationOwnProps> = {
  fetchData,
  toggleConfig,
  closeAlert,
  resetState,
};

export const TwoFactorConfigurationContainer = connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(TwoFactorConfiguration);
